var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative flex flex-col"},[_c('div',{staticClass:"flex w-full mx-auto h-auto lg:grid lg:grid-cols-side-main"},[_c('div',{staticClass:"col-span-2 relative w-full xl:container mx-auto overflow-hidden sm:px-10 lg:px-6 mb-32 flex flex-col"},[_c('ErrorContent')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }